/* eslint-disable prefer-promise-reject-errors */
import shp from 'shpjs';
import fileToArrayBuffer from 'file-to-array-buffer';
import tj from 'togeojson';
import wkt from 'wkt';
import kmzToKml from './KmzToKml';

const fileTypes = ['wkt', 'kml', 'kmz', 'shp', 'zip'];
const parser = new DOMParser();

export default {
    async parse(extension, content, rawFile) {
        let arquivoFormatoValido = fileTypes.indexOf(extension) > -1;

        if (!arquivoFormatoValido) {
            return new Promise((resolve, reject) => {
                reject('Tipo de arquivo não permitido.');
            });
        }

        let data = null;

        switch (extension) {
            case 'wkt':
                data = {
                    features: [
                        {
                            geometry: wkt.parse(content)
                        }
                    ]
                };
                break;

            case 'kml':
                const xmlDoc = parser.parseFromString(content, 'text/xml');

                data = tj.kml(xmlDoc);
                break;

            case 'kmz':
                await kmzToKml.parse(rawFile).then(kmlDom => {
                    data = tj.kml(kmlDom);
                });
                break;

            case 'zip':
                let arrayBuffer = null;

                await fileToArrayBuffer(rawFile).then(buffer => {
                    arrayBuffer = buffer;
                });

                data = await shp(arrayBuffer);

                break;

            case 'shp':
                return new Promise((resolve, reject) => {
                    reject(
                        'Faça o upload de um zip com os arquivos do shapefile'
                    );
                });
        }

        return new Promise((resolve, reject) => {
            resolve(data);
        });
    }
};
